import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { QuoteDataCaptureService, UtilService, ModalScroll, FormValidationsService, SERVICE_END_POINT, AnalyticsService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Subscription, Observable } from 'rxjs';
import * as UserDataConfig from '../../config/user-data.config';
import { ClearToApply } from 'src/app/model/ngrx/clear-to-apply.model';
import * as ClearToApplyActions from '../../../../store/actions/clear-to-apply.actions';
import * as RefNoActions from '../../../../store/actions/reference-number.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import * as loggedInDetailActions from '../../../../store/actions/loggedin-detail.action';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';

@Component({
  selector: 'app-clear-to-apply',
  templateUrl: './clear-to-apply.component.html',
  styleUrls: ['./clear-to-apply.component.scss']
})
export class ClearToApplyComponent implements OnInit {
  userForm: UntypedFormGroup;
  clearToApplyForm: UntypedFormGroup;
  contentData;
  getQueryParameters;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public nextButtonDisabled: boolean;
  public noSelectedFlag: boolean;
  clearToApplyStore: Observable<ClearToApply[]>;
  clearToApply: ClearToApply;
  // public dontShowMsgAgain: boolean;
  // public noWarningMSg: boolean;
  // protected packAlertModalConfig: AlertModal = new AlertModal('alert', "A message you should pay attention to", '', 'OK', '', '');
  // protected packAlertModalConfig: AlertModal;
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  protected resposeJsonQuoteCaptureStore: {};
  protected resultQuote: {};
  protected CMSData;
  public loginDetail: any;
  protected resultAnalytic: {};
  clearToApplyStoreSubscription: Subscription;
  screenName;
  isHOView = false;
  public protectionTypeConfig = this.userInputDetail.protectionTypeConfig;
  displayLTAProtectionTypeWarningMsg: boolean = false;
  displayTooltipAlert: boolean = false;
  tooltipModal;
  public tooltipModalConfig: AlertModal;

  constructor(private fb: UntypedFormBuilder, private router: Router,
              private activatedRoute: ActivatedRoute, private store: Store<AppState>,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private authService: AuthService,
              private btnFocusOnModalClose: ModalScroll, public el: ElementRef,
              private utilService: UtilService,
              private applicationDatacaptureService: ApplicationDataCaptureService, private analyticsService: AnalyticsService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.clearToApply;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.clearToApplyStore = store.select(STORE_VAL.clear_apply);
    this.clearToApplyStoreSubscription = this.clearToApplyStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.clearToApply = val[0];
        if(this.isHOView == true) {
          this.displayClearToApplyData(this.clearToApply);
        }
      }
    });

    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resposeJsonQuoteCaptureStore = res[0];
        this.resultQuote = this.resposeJsonQuoteCaptureStore;
        this.resultAnalytic = this.resposeJsonQuoteCaptureStore;
        let TFCAmount = (this.resultAnalytic['totalTaxFreeCashAmount']) ? this.resultAnalytic['totalTaxFreeCashAmount'] : 0;
        let TFCExtAmount = (this.resultAnalytic['totalExtTaxFreeCashAmount']) ? this.resultAnalytic['totalExtTaxFreeCashAmount'] : 0;
        let TFCTotalAmount = TFCAmount + TFCExtAmount
        this.analyticsService.orderTrack({ internalReferenceDCJ: this.resultAnalytic['quoteRefNo'],quoteReference:this.resultAnalytic['padsRefNo']});
        this.analyticsService.productsTrack({'channel': this.resultAnalytic['source'],'annualIncome':this.resultAnalytic['annualIncome'],'startDate':this.resultAnalytic['startDate'],
                                             'incomeRegularity':this.resultAnalytic['paymentFrequency'],'incomeType':this.resultAnalytic['paymentAdvance'],
                                             'incomeIncreaseOption':this.resultAnalytic['escalationType'],'incomeIncreaseValue':this.resultAnalytic['escalationRate'],
                                             'incomeProtectionOption':this.resultAnalytic['vpIndicator'],'incomeProtectionValue':this.resultAnalytic['vpPercentage'],
                                             'guaranteedIncomePeriod':this.resultAnalytic['guaranteedTerm'],'dependantIncome':this.resultAnalytic['secondLifePensionPercentage'],
                                             'lumpSumOption':this.resultAnalytic['taxFreeCashAmountPercent'],'lumpSumValue':TFCTotalAmount,
                                             'purchasePotValue':this.resultAnalytic['netAmount'],'monthlyIncome':this.resultAnalytic['annualIncome'] && this.resultAnalytic['paymentFrequency'] == 'M' ? this.resultAnalytic['annualIncome'] / 12 : 0,
                                            });
        if(this.resultAnalytic['compQuote'] && this.resultAnalytic['compQuote']['errorMessage'])
          this.analyticsService.errorAnalyticsTrack({formErrorMessage: this.resultAnalytic['compQuote']['errorMessage'], formErrorType: 'Validation Errors', formErrorDetail: '0', formErrorCount: 1 })
      }
    });

    store.select(STORE_VAL.application_data_response).subscribe(res => {
      if (res && res.length > 0) {
        this.resposeJsonQuoteCaptureStore = res[0];
        this.resultQuote = this.resposeJsonQuoteCaptureStore['quoteFundInfo'][0];
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.getQueryParameters = params;
      // this.applicationDatacaptureService.triggeredBy = 'HO';
    });

    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
        let customerAge =  (this.loginDetail['customer'].dateOfBirth !='' &&  this.loginDetail['customer'].dateOfBirth !=null) ? this.loginDetail['customer'].dateOfBirth : '' ;
        let totalAge;
        if(customerAge) {
          totalAge  = (new Date().getFullYear()) - (Number(customerAge.split('/')[2]))
        }
       let personData =  { 
                             'age': (totalAge) ? totalAge : '',
                             'dateOfBirth': this.loginDetail['customer'].dateOfBirth, 
                             'gender': (this.loginDetail['customer'].gender && this.loginDetail['customer'].gender == 'M') ? 'Male': 'Female', 
                             'postcode': this.loginDetail['customer']['address'].postcode, 
                             'email': this.loginDetail['customer'].emailAddress,
                             'forename': this.loginDetail['customer'].forename,
                             'surname': this.loginDetail['customer'].surname,
                             'mobilePhone': this.loginDetail['customer'].mobilePhone,
                             'homePhone': this.loginDetail['customer'].homePhone,
                             'quoteEmail': (this.loginDetail['customer'].internalSoftOptInInd == 'Y') ? 'Y' : (this.loginDetail['customer'].internalSoftOptInInd == 'N') ? 'N': ''

                            }
                            this.analyticsService.customerTrack({ ...personData});  
      }
    });
  }

  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.GetCMSDataServiceMapper();
    this.analyticsService.orderTrack({ internalReferenceDCJ: this.resposeJsonQuoteCaptureStore['quoteRefs'][0], applicationReferenceDCJ:this.resposeJsonQuoteCaptureStore['applicationId']});
  }

  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  setClearToApplyForm() {
    this.clearToApplyForm = this.fb.group({
      bankrupt: [null, Validators.required],
      lifeTimeAllowance: [null],
      pensionPolicy: [null, Validators.required],
      // guaranteedStartDate: [this.resultQuote ? this.dateFormat(this.resultQuote[0].startDate) : null],
      ltaProtection: [null],
      ltaProtectionType: [null]
    });
  }

  displayClearToApplyData(clearToApply){
    this.clearToApplyForm = this.fb.group({
      bankrupt: [clearToApply.bankrupt, Validators.required],
      lifeTimeAllowance: [null],
      pensionPolicy: [clearToApply.pensionPolicy, Validators.required],
      // guaranteedStartDate: [this.resultQuote ? this.dateFormat(this.resultQuote[0].startDate) : null],
      ltaProtection: [null],
      ltaProtectionType: [null]
    });
  }
  createQuestionarray(): any {
    const questionArray = [];
    if (this.clearToApplyForm.controls.bankrupt.value) {
      questionArray.push({
        questionCode: 'bankruptQuestion',
        questionType: this.contentData.bankruptQuestion.questionType,
        answer: this.clearToApplyForm.controls.bankrupt.value
      });
    }
    if (this.clearToApplyForm.controls.lifeTimeAllowance.value) {
      questionArray.push({
        questionCode: 'lifeTimeAllowanceQuestion',
        questionType: this.contentData.lifeTimeAllowanceQuestion.questionType,
        answer: this.clearToApplyForm.controls.lifeTimeAllowance.value
      });
    }
    if (this.clearToApplyForm.controls.pensionPolicy.value) {
      questionArray.push({
        questionCode: 'pensionPolicyQuestion',
        questionType: this.contentData.pensionPolicyQuestion.questionType,
        answer: this.clearToApplyForm.controls.pensionPolicy.value
      });
    }
    if (this.clearToApplyForm.controls.ltaProtection.value) {
      questionArray.push({
        questionCode: 'ltaProtectionQuestion',
        questionType: this.contentData.ltaProtectionQuestion.questionType,
        answer: this.clearToApplyForm.controls.ltaProtection.value
      });
    }
    return questionArray;
  }
  goBack() {
    this.saveFormValues();
    this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
      this.router.navigate(['/quote/your-saved-quotes']);
    });
   
  }
  gotoNext = () => {
    if (this.clearToApplyForm.valid && !this.noSelectedFlag) {
      this.saveFormValues();
      this.btnFocusOnModalClose.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        //console.log(res);
        this.router.navigate(['/apply/your-personal-details']);
      });
    } else {
      FormValidationsService.validateAllFormFields(this.clearToApplyForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }

    if (this.clearToApplyStoreSubscription) {
      this.clearToApplyStoreSubscription.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  saveFormValues() {
    this.store.dispatch(new ClearToApplyActions.RemoveClearToApply(0));
    this.store.dispatch(new ClearToApplyActions.AddClearToApply({
      bankrupt: this.clearToApplyForm.controls.bankrupt.value ? this.clearToApplyForm.controls.bankrupt.value : null,
      // tslint:disable-next-line:max-line-length
      lifeTimeAllowance: this.clearToApplyForm.controls.lifeTimeAllowance.value ? this.clearToApplyForm.controls.lifeTimeAllowance.value : null,
      pensionPolicy: this.clearToApplyForm.controls.pensionPolicy.value ? this.clearToApplyForm.controls.pensionPolicy.value : null,
      // guaranteedStartDate: this.resultQuote ? this.dateFormat(this.resultQuote['startDate']) : null,
      guaranteedStartDate: '01/01/2020',
      ltaProtection: this.clearToApplyForm.controls.ltaProtection.value ? this.clearToApplyForm.controls.ltaProtection.value : null,
      // tslint:disable-next-line:max-line-length
      ltaProtectionType: this.clearToApplyForm.controls.ltaProtectionType.value ? this.clearToApplyForm.controls.ltaProtectionType.value : null,
      riskAndStaticQuestion: this.createQuestionarray(),
    }));
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  dateFormat = (dateValue: string) => {
    return dateValue.indexOf('/') > -1 ? (dateValue.split('/').join(' / ')) : dateValue;
  }

    /** Code block for CMS */
    GetCMSDataServiceMapper() {
      const URL = SERVICE_END_POINT.higherEnvironment.CMS_BeforeYouApply;
      //console.log('changed value = ', );
      this.utilService.getCMSData(URL).subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.header = this.CMSData.string_BeforeYouApplyTitle;
          this.contentData.introduction = this.CMSData.string_BeforeYouApplySubTitle;
          this.contentData.bankruptQuestion.questionStatement = this.CMSData.string_BankruptQuestion;
          this.contentData.lifeTimeAllowanceQuestion.questionStatement = this.CMSData.string_LTAQuestion;
          this.contentData.pensionPolicyQuestion.questionStatement = this.CMSData.string_PensionCreditQuestion;
          this.contentData.bankruptQuestion.infoIconData.content = this.CMSData.string_BankruptInformationWording;
          this.contentData.lifeTimeAllowanceQuestion.infoIconData.content = this.CMSData.string_LTAInformationWording;
          this.contentData.pensionPolicyQuestion.infoIconData.content = this.CMSData.string_PensionSharingInformationWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.bankruptQuestion.questionOptions.find(res => res['label'] === 'Yes').infoText = this.CMSData.string_BankruptWarningMessageWording;
          // tslint:disable-next-line:max-line-length
          // this.contentData.lifeTimeAllowanceQuestion.questionOptions.find(res => res['label'] === 'No').infoText = this.CMSData.string_LTAWarningMessageWording;
          // tslint:disable-next-line:max-line-length
          this.contentData.pensionPolicyQuestion.questionOptions.find(res => res['label'] === 'Yes').infoText = this.CMSData.string_PensionCreditWarningMessageWording;
          this.contentData.ltaProtectionQuestion.questionStatement = this.CMSData.string_LTAProtectionQuestion;
          this.contentData.ltaProtectionQuestion.infoIconData.content = this.CMSData.string_LTAProtectionInfoPoint;
          this.contentData.ltaProtectionQuestion.validationMsg = this.CMSData.string_LTAProtectionError;
          this.protectionTypeConfig.label = this.CMSData.string_LTAProtectionType;
          this.protectionTypeConfig.errorMessage = this.CMSData.string_LTAProtectionTypeError;
          this.contentData.ltaProtectionTypeWarning = this.CMSData.string_LTAProtectionMessage;
          this.contentData.string_PensionWiseCopy = this.CMSData.string_PensionWiseCopy;
          this.contentData.string_PensionWiseTitle = this.CMSData.string_PensionWiseTitle;
          this.screenDataBinding();
        }
      });
    }
    /** End of code block for CMS */
    /** For web tracking */
    getCurrentScreenURL() {
      this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
      return this.screenName;
    }
    lifetimeAllowanceReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
    pensionCreditReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
    benefitGuaranteedReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
    ddlChange() {
      this.displayLTAProtectionTypeWarningMsg = this.clearToApplyForm.get('ltaProtectionType').value === 'F'
        || this.clearToApplyForm.get('ltaProtectionType').value === 'E'
        || this.clearToApplyForm.get('ltaProtectionType').value === 'P' ? true : false;
    }
  toggleChangeLTA(data, ctrlName) {
    switch (ctrlName) {
      case 'lifeTimeAllowance':
        if (data === 'Y') {
          this.clearToApplyForm.controls['ltaProtection'].setValidators([Validators.required]);
        } else {
          this.clearToApplyForm.controls['ltaProtection'].clearValidators();
          this.clearToApplyForm.controls['ltaProtection'].setValue(null);
          this.clearToApplyForm.controls['ltaProtectionType'].clearValidators();
          this.clearToApplyForm.controls['ltaProtectionType'].setValue(null);
          this.displayLTAProtectionTypeWarningMsg = false;
        }
        break;
      case 'ltaProtection':
        if (data === 'Y') {
          this.clearToApplyForm.controls['ltaProtectionType'].setValidators([Validators.required]);
        } else {
          this.clearToApplyForm.controls['ltaProtectionType'].clearValidators();
          this.clearToApplyForm.controls['ltaProtectionType'].setValue(null);
          this.displayLTAProtectionTypeWarningMsg = false;
        }
        break;
      default:
        break;
    }
  }

  screenDataBinding() {
    if (this.getQueryParameters && this.getQueryParameters['applcationRefNo']) {
      this.isHOView = true;
      this.applicationDatacaptureService.resumeApplicationFromHO(this.getQueryParameters['applcationRefNo'], false);
    }

    if (this.clearToApply) {
      this.displayLTAProtectionTypeWarningMsg = this.clearToApply.ltaProtectionType === 'F'
        || this.clearToApply.ltaProtectionType === 'E'
        || this.clearToApply.ltaProtectionType === 'P' ? true : false;
      this.clearToApplyForm = this.fb.group({
        bankrupt: [this.clearToApply.bankrupt, Validators.required],
        lifeTimeAllowance: [null],
        pensionPolicy: [this.clearToApply.pensionPolicy, Validators.required],
        // guaranteedStartDate: [this.resultQuote ? this.dateFormat(this.resultQuote[0].startDate) : null]
        ltaProtection: [this.clearToApply.ltaProtection],
        ltaProtectionType: [this.clearToApply.ltaProtectionType]
      });

    } else {
      this.setClearToApplyForm();
    }
    this.userFormData();
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress =  this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.clearToApplyForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }

   displayTooltipMessage(data: any){
    if (data === 'bankrupt') {
      let config = this.contentData.bankruptQuestion.infoIconData;
      this.tooltipModal.content = config.content.replace('<a', '<a class="moneyhelperTxt"');
      this.displayTooltipAlert = true;
    }
    else if (data === 'pensionPolicy') {
      let config = this.contentData.pensionPolicyQuestion.infoIconData;
      this.tooltipModal.content = config.content.replace('<a', '<a class="moneyhelperTxt"');
      this.displayTooltipAlert = true;
    }

  }

   closeModal() {
    this.displayTooltipAlert = false;
  }

  
  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
}
